import React from "react"
import { Tooltip } from "antd"
import PropTypes from "prop-types"
import SuccessBadge from "components/badges/SuccessBadge/SuccessBadge"
import "./PrsUploadStatusCell.scss"

const PrsUploadStatusCell = ({ value, data }) => {
  const getBadgeVariant = (value) => {
    if (
      value === "Study Unchanged" ||
      value === "Study Changed" ||
      value === "Unchanged Study" ||
      value === "Changed Study"
    ) {
      return "success"
    } else if (value === "New Study") {
      return "new"
    } else if (value === "Failed" || value === "Error") {
      return "fail"
    }
  }

  return (
    <Tooltip title={data?.prs_failure_message}>
      <div className="prs-upload-status">
        {getBadgeVariant(value) && (
          <SuccessBadge
            variant={getBadgeVariant(value)}
            className="prs-upload-status-badge"
          />
        )}
        {value}
      </div>
    </Tooltip>
  )
}

PrsUploadStatusCell.propTypes = {
  value: PropTypes.oneOf([
    "Study Unchanged",
    "Unchanged Study",
    "Study Changed",
    "Changed Study",
    "New Study",
    "Failed",
    "Error",
  ]),
}

export default PrsUploadStatusCell
